// TableRowComponent.jsx
import React from 'react';
import { Checkbox } from '@mui/material';
import TBodyRight from './TBodyRight';
import formatDate from '../../../../components/common/formatDate';
import { TableInput } from '../../../../components/common';
import { useQuery } from '../../../../hooks/UseQuery';
import AutocompleteMuiCustomRevised from '../../../../components/common/tableinputs/AutocompleteMuiCustomRevised';

export const TableRowComponent = React.memo(
  ({
    key,
    item,
    empData,
    index,
    allmonth,
    updateModuleData,
    selectionArray,
    handleBulkDeleteFeature,
    headerTopicData,
  }: any) => {
    const isView = useQuery('isView') === 'true' ? true : false;
    const rowId = item?._id || item?._tempId;
    const isChecked = selectionArray[index] === rowId;

    const handleInputChange = (
      fieldName: string,
      value: string | number | null
    ) => {
      updateModuleData('row', index, fieldName, { [fieldName]: value });
    };

    const handleAutocompleteChange = (newValue: any) => {
      updateModuleData('row', index, 'employee_id', {
        ['employee_id']: newValue?.employee_id,
      });
      updateModuleData('row', index, 'list', {
        ['list']: newValue?.list,
      });
      updateModuleData('row', index, 'department_name', {
        ['department_name']:
          newValue?.employee_id?.department_id?.department_name || null,
      });
      updateModuleData('row', index, 'employee_name', {
        ['employee_name']: newValue?.employee_name || null,
      });
      updateModuleData('row', index, 'designation', {
        ['designation']: newValue?.designation || null,
      });
    };

    const handleCheckboxChange = (event: any) => {
      handleBulkDeleteFeature(index, event.target.checked, rowId);
    };

    return (
      <React.Fragment key={key}>
        <tr>
          <td>{index + 1}</td>
          <td>
            {item?._id && item?.employee_id === null ? (
              item?.employee_name
            ) : (
              <AutocompleteMuiCustomRevised
                id="employee_name."
                label=""
                option_name="employee_name"
                key={'employee_name'}
                arrayofObj={empData}
                value={item?.employee_id}
                onChange={(_, newValue: any) => {
                  handleAutocompleteChange(newValue);
                }}
                sx={{ width: '200px' }}
              />
            )}
          </td>

          <td>{item?.employee_id?.designation || item?.designation}</td>
          <td>
            {item?.employee_id?.department_id?.department_name ||
              item?.department_name}
          </td>

          {/* 👉 */}
          <TBodyRight
            item={item}
            isView={isView}
            index={index}
            headerTopicData={headerTopicData}
            updateModuleData={updateModuleData}
          />
          {/* ❌ */}

          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="remarks"
              type="text"
              value={item.remarks}
              onChange={(e: any) =>
                handleInputChange('remarks', e.target.value)
              }
            />
          </td>

          <td>
            <Checkbox
              style={{ color: '#fa5252' }}
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
          </td>
        </tr>
        {/* ---x---- */}
      </React.Fragment>
    );
  },
  (prevProps, nextProps) => {
    // Check if the relevant data for this row has changed
    return (
      prevProps.item === nextProps.item &&
      prevProps.selectionArray[prevProps.index] ===
        nextProps.selectionArray[nextProps.index]
    );
  }
);
